import React, { useState } from 'react';
import FormModal from '../../../common/FormModal';

const AddExperienceModal = ({ isOpen, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    url: ''
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    setFormData({ name: '', url: '' });
  };

  const handleClose = () => {
    setFormData({ name: '', url: '' });
    onClose();
  };

  return (
    <FormModal
      isOpen={isOpen}
      onClose={handleClose}
      onSubmit={handleSubmit}
      title="إضافة تجربة جديدة"
      submitText="إضافة"
      cancelText="إلغاء"
    >
      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            السنة
          </label>
          <input
            type="text"
            value={formData.name}
            onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            className="input-base"
            placeholder="مثال: 2023"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
            الرابط
          </label>
          <input
            type="text"
            value={formData.url}
            onChange={(e) => setFormData({ ...formData, url: e.target.value })}
            className="input-base"
            placeholder="مثال: /2023"
          />
        </div>
      </div>
    </FormModal>
  );
};

export default AddExperienceModal;
